<template>
  <v-card align="center" justify="center" light min-width="20vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title') }} {{ brokerAccount.broker.name }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <v-form v-model="valid">
        <v-img class="mb-5" src="https://images.squarespace-cdn.com/content/v1/5d849fb37a733a2e699b3774/1588861945863-2ID74IHT0Y1VGKLYE497/Metatrader4?format=1000w" max-width="70"/>
        <v-select :label="$t('versionLabel')" :items="versions" item-text="text" item-value="value" disabled
                  v-model="version" :rules="versionRules" outlined/>
        <v-select :label="$t('serverLabel')" :items="servers" item-text="name" item-value="host"
                  v-model="server" :rules="serverRules" outlined/>
        <v-text-field :label="$t('loginLabel')" :placeholder="$t('loginPlaceholder')"
                      v-model="login" :rules="loginRules" outlined/>
        <v-text-field :label="$t('investorPasswordLabel')" :placeholder="$t('investorPasswordPlaceholder')"
                      v-model="investorPassword" :rules="investorPasswordRules" outlined/>
        
        <p style="font-size: 15px; color: #6b6b6b" class="text-start mb-7" v-html="$t('complianceMessageUrl')"/>
        <v-btn :disabled="!valid" class="mt-2" @click="linkMetaTrader">{{ $t('btnLink') }}</v-btn>
      </v-form>
    </v-card-text>
    <v-overlay v-model="waitingRequest">
        <lottie :options="lottieOptions" :height="250" :width="250"/>
    </v-overlay>
  </v-card>
</template>

<script>
import * as animationData from '@/assets/animations/loading.json';
import Repository from '../../../repositories/metaTraderCredentials';

export default {
  name: "LinkMetaTrader",
  props: {
    brokerAccount: Object,
  },
  data() {
    return {
      lottieOptions: { animationData: animationData.default, },
      waitingRequest: false,
      existingCredentialsId: -1,
      servers: [
        //{ name: 'Ava-Demo', host: 'demo.ava-mt.com' },
        //{ name: 'Ava-Demo', host: 'demo.ava-mt.com' },
        //{ name: 'Ava-Demo 2', host: 'demo.ava-mt-2.com' },
        //{ name: 'Equiti-Demo', host: 'demo.equiti-demo.com' },
        //{ name: 'Equiti-Live', host: 'demo.equiti-live.com' },
        //{ name: 'EquitiGroup-Demo', host: 'demo.equitigroup-demo.com' },
        //{ name: 'EquitiGroup-Live', host: 'demo.equitigroup-live.com' },
        //{ name: 'EquitiGroup-Live 2', host: 'demo.equitigroup-live-2.com' },
        { name: 'ZenfinexGlobal-Demo', host: '52.56.239.235' },
        { name: 'ZenfinexGlobal-Live', host: '18.168.113.125' },
        { name: 'WorldTraders-Demo', host: '51.91.105.144' },
      ],
      versions: [
        { text: 'MetaTrader 4', value: 'MT4' },
        { text: 'MetaTrader 5', value: 'MT5' },
      ],
      server: '',
      login: '',
      investorPassword: '',
      version: '',
      // Validation
      valid: false,
      versionRules: [
        v => !!v || this.$t('validations.versionMandatory'),
      ],
      serverRules: [
        s => !!s || this.$t('validations.serverMandatory'),
      ],
      loginRules: [
        l => !!l || this.$t('validations.loginMandatory'),
        l => (l && l.length <= 15) || this.$t('validations.loginMaxLength'),
      ],
      investorPasswordRules: [
        i => i.length <= 25 || this.$t('validations.investorPasswordMaxLength'),
      ],
      checkboxRules: [
        c => !!c || this.$t('validations.checkboxMandatory'),
      ],
    };
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      this.server = this.servers[0].host;
      this.version = this.versions[0].value;
      Repository.getCredentialsByBrokerAccountId(this.brokerAccount.id).then((response) => {
        if(response.status < 400) {
          let retrievedCredentials = response.data;
          this.server = retrievedCredentials.server;
          this.login = retrievedCredentials.login;
          this.investorPassword = retrievedCredentials.password;
          this.existingCredentialsId = retrievedCredentials.id;
          this.version = retrievedCredentials.version;
        }
      });
    },
    linkMetaTrader() {
      let metaTraderCredentials = {
        brokerAccount: { id: this.brokerAccount.id },
        server: this.server,
        login: this.login,
        password: this.investorPassword,
        version: this.version,
      };

      if(this.existingCredentialsId !== -1)
        metaTraderCredentials.id = this.existingCredentialsId;

      this.waitingRequest = true
      let promise = (this.existingCredentialsId === -1)? Repository.createCredentials(metaTraderCredentials) : Repository.updateCredentials(metaTraderCredentials);
      promise.then((response) => {
        if(response.status < 400) {
          alert((this.existingCredentialsId === -1)? this.$t('alerts.successfullyCreated') : this.$t('alerts.successfullyModified'));
          this.close();
        }
        this.waitingRequest = false
      })
      promise.catch((error) => {
          let errorKey = error.response.data.errorKey
          if(errorKey==='idexists'){
            alert(this.$t('alerts.errors.idexists'));
          }else if(errorKey==='metacredentialInvalid'){
            alert(this.$t('alerts.errors.metacredentialInvalid'));
          }else{
            alert(this.$t('alerts.errors.genError'));
          }
          this.waitingRequest = false;
      })
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Link MetaTrader ",
    "versionLabel": "MetaTrader Version",
    "serverLabel": "Broker Server",
    "loginLabel": "Account Login",
    "investorPasswordLabel": "Investor Password",
    "loginPlaceholder": "Eg. 17457885",
    "investorPasswordPlaceholder": "Eg. ca4d5sa7",
    "alerts": {
      "successfullyCreated": "Credentials were created and linked successfully!",
      "successfullyModified": "Credentials were modified and linked successfully!",
      "errors": {
        "genError": "An error occurred, please try again.",
        "metacredentialInvalid": "Invalid credentials, check login and the investor password",
        "idexists": "ID inconsistency"
      }
    },
    "validations": {
      "versionMandatory": "Version is mandatory",
      "serverMandatory": "Server is mandatory",
      "loginMandatory": "Login is mandatory",
      "loginMaxLength": "Max length of 15 digits",
      "investorPasswordMaxLength": "Max length of 25 characters",
      "checkboxMandatory": "Confirmation is mandatory"
    },
    "complianceMessageUrl": "To see our full Terms and Conditions <a href='https://swiset.com/terms-and-conditions' target='_blank'>click here</a>.",
    "btnLink": "Link Now"
  },
  "es": {
    "title": "Vincular MetaTrader de ",
    "versionLabel": "Versión de MetaTrader",
    "serverLabel": "Servidor del Broker",
    "loginLabel": "Login de Cuenta",
    "investorPasswordLabel": "Contraseña de Inversionista",
    "loginPlaceholder": "Ej: 17457885",
    "investorPasswordPlaceholder": "Ej: ca4d5sa7",
    "alerts": {
      "successfullyCreated": "¡Credenciales fueron creadas y vinculadas satisfactoriamente!",
      "successfullyModified": "¡Credenciales fueron modificadas y vinculadas satisfactoriamente!",
      "errors": {
        "genError": "Ocurrió un error, intente de nuevo.",
        "metacredentialInvalid": "Credenciales invalidas, revise el login y la contraseña de inversionista",
        "idexists": "Inconsistencia de ID"
      }
    },
    "validations": {
      "versionMandatory": "Versión es obligatorio",
      "serverMandatory": "Servidor es obligatorio",
      "loginMandatory": "Login es obligatorio",
      "loginMaxLength": "Máximo 15 dígitos",
      "investorPasswordMaxLength": "Máximo 25 dígitos",
      "checkboxMandatory": "Es necesario confirmar"
    },
    "complianceMessageUrl": "Ver los términos y condiciones <a href='https://swiset.com/es/terminos-y-condiciones' target='_blank'>dando click aquí</a>.",
    "btnLink": "Vincular Ahora"
  }
}
</i18n>

<style scoped>

</style>
